import { render, staticRenderFns } from "./ItemMenuMobile.vue?vue&type=template&id=19f95970&scoped=true&"
import script from "./ItemMenuMobile.vue?vue&type=script&lang=js&"
export * from "./ItemMenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./ItemMenuMobile.vue?vue&type=style&index=0&id=19f95970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f95970",
  null
  
)

export default component.exports